import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheck02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    strokeWidth={1.5}
    stroke="currentColor"
    aria-hidden="true"
    width="100%"
    height="100%"
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M10 3 4.5 8.5 2 6" />
  </svg>
);
export default SvgCheck02;
